var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediuminline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.5 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0,0H31.5V31.5H0ZM26.16,7.45V7.1H20.32L16.17,17.51,11.39,7.1H5.27v.35l2,2.39a.7.7,0,0,1,.28.71V19.9a1.09,1.09,0,0,1-.28.91L5,23.48v.36h6.33v-.36L9.07,20.81a1.09,1.09,0,0,1-.28-.91V11.81l5.55,12H15l4.71-12v9.64a.61.61,0,0,1-.14.42l-1.69,1.68v.36h8.3v-.36l-1.69-1.61a.48.48,0,0,1-.14-.49V9.56a.48.48,0,0,1,.14-.49Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediuminline);
export default __webpack_public_path__ + "static/media/medium.inline.777ad89e98e24390c61a335798a71123.svg";
export { ForwardRef as ReactComponent };